import { Cookies } from 'react-cookie';
import { IToken, IUser } from '../store/userStore';

export interface StoredToken {
  user: IUser;
  token: IToken;
}

const cookies = new Cookies();

// Set both token and user data
export const setToken = (authData: StoredToken): void => {
  // Ensure we are storing the serialized version of the data
  const serializedAuthData = JSON.stringify(authData);
  cookies.set('authData', serializedAuthData, {
    path: '/',
    sameSite: 'strict',
    secure: true,
  });
};

// Get token and user data from cookies
export const getToken = (): StoredToken | null => {
  const authObj = cookies.get('authData');
  
  // If the data is already parsed, no need to parse again.
  if (authObj && typeof authObj === 'string') {
    return JSON.parse(authObj);
  }

  return authObj || null;
};

// Remove token and user data from cookies
export const removeToken = (): void => {
  cookies.remove('authData', { path: '/' });
};
